import { render, staticRenderFns } from "./FilterWishesTrash.vue?vue&type=template&id=542f0d02&scoped=true"
import script from "./FilterWishesTrash.vue?vue&type=script&lang=js"
export * from "./FilterWishesTrash.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542f0d02",
  null
  
)

export default component.exports